<template>
    <div>
        <CRow>
            <CCol>
                <div style="width:100%; height: 75vh;">
                    <ejs-grid ref='gridrl' :dataSource='ricLogData' :allowFiltering='true' :allowPaging='true' :allowResizing='true'
                              :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :toolbarClick='toolbarClick'
                              :allowExcelExport='true' :excelExportComplete='excelExportComplete':excelQueryCellInfo='excelQueryCellInfo'
                              :pageSettings='pageSettings' :filterSettings='filterOptions'  :actionBegin='actionBegin' 
                              :actionFailure="actionFailure" :actionComplete="actionComplete" :queryCellInfo='queryCellInfo'
                               width="100%" height="100%">
                        <e-columns>
                            <e-column field='ricLogid' headerText='Identifier Log Id' :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='ricId' headerText='Identifier Id' :visible='true'></e-column>
                            <e-column field='stateName' headerText='Country' textAlign='Left' width=180 type="string"></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='utilityTypeName' headerText='Commodity'></e-column>
                            <e-column field='activeMonth' headerText='Active Month' displayAsCheckBox='true' type='boolean'></e-column>
                            <e-column field='core' headerText='Identifier' typeof="string" width=180></e-column>
                            <e-column field='coreExtension' headerText='Identifier Extension' width=180></e-column>
                            <e-column field='product' headerText='Product' width=180></e-column>
                            <e-column field='providerTypeName' headerText='Provider Type' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='monthsAhead' headerText='Months Ahead' textAlign='Right' width=180></e-column>
                            <e-column field='quartersAhead' headerText='Quarters Ahead' textAlign='Right' width=180></e-column>
                            <e-column field='seasonssAhead' headerText='Seasons Ahead' textAlign='Right' width=180></e-column>
                            <e-column field='yearsAhead' headerText='Years Ahead' textAlign='Right' width=180></e-column>
                            <e-column field='parentName' headerText='Parent Identifier' textAlign='Right' width=180></e-column>
                            <e-column field='benchmarkName' headerText='Benchmark Identifier' textAlign='Right' width=180></e-column>
                            <e-column field='isDeleted' headerText='Deleted' textAlign='Right' width=180></e-column>
                            <e-column field='logDate' headerText='Log Date' textAlign='Left' width=190 type="date" :format="dateFormatOptions"></e-column>
                            <e-column field='logTime' headerText='Log Time' textAlign='Left' type='string' width=150></e-column>
                            <e-column field='userName' headerText='User' textAlign='Left' width=150 type="string"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </CCol>
        </CRow>
    </div>
</template>
<script>

    import Vue from "vue";
    import { GridPlugin, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    export default {
        name: 'RICLogs',
        data() {
            return {
                store: store,
                ricLogData: SyncHelper.getDataManager("ricLog"),
                pageSettings: gridOptions.pageSettings,
                filterOptions: gridOptions.filterSettings,
                toolbar: ['ExcelExport'],
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                activeMonthValue: false
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Energy Instruments Logs.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridrl.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            queryCellInfo(args) {
                if (args.column.field === 'logTime') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['logTime']);
                }
                if (args.column.field === 'logDate') {
                    args.cell.textContent = this.convertUTCDateToLocaDate(args.data['logDate']);
                }
            },
            excelQueryCellInfo: function (args) {
                if (args.column.field === 'logTime') {
                    args.value = this.convertUTCDateToLocalTime(args.data['logDate']);
                }
                if (args.column.field === 'activeMonth') {
                    args.value = args.data.activeMonth == false ? "No" : "Yes";
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            convertUTCDateToLocaDate(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleDateString();
            }
        },
        provide: {
            grid: [Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport]
        }
    }
</script>